import { render } from "./App.vue?vue&type=template&id=101f64ec"
const script = {}

import "./App.vue?vue&type=style&index=0&id=101f64ec&lang=css"

import exportComponent from "/var/www/coursat-mtn-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__